import { prop } from 'ramda';

import { compact } from '../../../../helpers/compact';
import { DocumentType } from '../../../../types/document';
import { toImageFromProp } from '../../fields/image';
import { toTextFromProp } from '../../fields/text';
import { relatedPushs } from '../../partials/related-push';
import { processSlices, commonSlices } from '../../slices';
import { deprecatedPageEntity } from './internal';

/**
 * @typedef  {Object} PrismicPublicServiceMissions
 */

/**
 * @typedef {DocumentSchema} PublicServiceMissionsSchema
 */

const processCustomSlices = processSlices(commonSlices);

/**
 * Transform the given input into objects
 *
 * @param  {PrismicPublicServiceMissions} data
 * @return {PublicServiceMissionsSchema}
 */
const processPublicServiceMissions = (data) =>
  compact({
    uid: DocumentType.PUBLIC_SERVICE_MISSIONS,
    type: DocumentType.PUBLIC_SERVICE_MISSIONS,
    title: toTextFromProp('title', data),
    illustration: toImageFromProp('image_src', data),
    chapeau: prop('chapeau', data),
    relatedPushs: relatedPushs(data),
    body: processCustomSlices(prop('slices', data)),
  });

/**
 * Normalizr schema representing a public-service-missions page
 */
export const PublicServiceMissionsEntity = deprecatedPageEntity(
  DocumentType.PUBLIC_SERVICE_MISSIONS,
  {
    processStrategy: (entity) => ({
      ...processPublicServiceMissions(prop('data', entity)),
    }),
  }
);
